import Icon from '../components/Icon.vue'

Icon.register({"table-tennis":{"width":512,"height":512,"paths":[{"d":"M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1L89.1 119.2 300.6 330.7C346.7 268.6 432.1 253.3 496.2 296.5zM278.3 376.2L57.9 155.9C30.6 201.2 36.2 260.9 75.2 300L109.7 334.6 6.7 424C-1.9 431.5-2.4 444.7 5.7 452.8L59.1 506.3C67.1 514.4 80.3 513.9 87.8 505.3L177.1 402 212.8 437.7C232.5 457.4 257.4 468.2 283.1 471 276 454 272.1 435.4 272.1 415.9 272 402.1 274.6 388.9 278.3 376.2zM416 320C363 320 320 363 320 416S363 512 416 512 512 469 512 416 469 320 416 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/table-tennis.js
// module id = null
// module chunks = 